import SignUp from './SignUp.page';

export default SignUp;